const externalBlockchainExplorers = {
  TBTC: 'https://testnet.smartbit.com.au/tx/',
  TETH: 'https://kovan.etherscan.io/tx/',
  TLTC: 'http://explorer.litecointools.com/tx/',
};

export default externalBlockchainExplorers;
